import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 7l-10 10","key":"svg-0"}],["path",{"d":"M16 17l-9 0l0 -9","key":"svg-1"}]]

/**
 * IconArrowDownLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctZG93bi1sZWZ0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNyA3bC0xMCAxMCIgLz4KICA8cGF0aCBkPSJNMTYgMTdsLTkgMGwwIC05IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/arrow-down-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowDownLeft = createReactComponent('outline', 'arrow-down-left', 'ArrowDownLeft', __iconNode);

export default IconArrowDownLeft;